/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react'
import AuctionHeader from '../../auctionHeader'
import ClassicPreview from './classicPreview'
import EventDisplayPreview from './eventDisplayPreview'
import SetupSection from '../commonLayout/setUpSection'
import SingleLotPreview from './singleLotPreview'
import MenuLinkModal from '../commonLayout/setUpSection/menuLinkModal'
import StandALonePreview from './standALonePreview'
import { generateInitialTermsAndCondition, initialFAQs, timeZoneMap } from '../../../../../CommonComponent/staticValues'
import { dataService } from '../../../../../services/dataService'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Storage } from 'aws-amplify'
import uuid from 'react-uuid';
import { useOnClickOutside } from '../../../../../CommonComponent/outsideClick'
import { convertToWebP } from '../../../../../CommonComponent/convertToWebp'
import { Triangle } from 'react-loader-spinner'
import { useSelector } from 'react-redux'
import { getOrphanedDescriptionImageKeys, getDescriptionImageUrls, getQuillModules } from '../../../../../config/quill'

export default function ClassicTemplate({ edit }) {

    const validTemplates = ['classic', 'single-lot', 'standalone'];

    function formatTemplateName(template) {
        const map = {
            'classic': 'Classic',
            'single-lot': 'Single Lot',
            'standalone': 'Standalone',
        };
        return map[template] || template;
    }

    const {id, template} = useParams();
    const state = useLocation();
    const price = useSelector((state)=>state.pricingSlice)
    const [editedAuctionData, setEditedAuctionData]=useState({});
    const outsideClickRef = useRef();
    const [isBanner, setIsBanner] = useState(true);
    const [showEventDisplayPreview, setShowEventDisplayPreview] = useState(false);
    const [loading, setLoading] = useState(false);
    const initialState = {
        template_name: formatTemplateName(template),
        menu_links: [],
        logo_image: "",
        logo_redirection_url: "",
        title: "",
        auction_image: "",
        description: "",
        currency: "USD",
        start_date: null,
        end_date: null,
        first_lot_end_date: null,
        extension_type: template== 'single-lot' ? "Individual Lots" : "All Lots",
        extension_time: "",
        extension_time_between_lots: "",
        registration_type: "Email only",
        add_buyer_fees: "Add percentage",
        percentage: price.plan_type=="Pro" ? '9' : '6',
        location: {
            address: '',
            latitude: '',
            longitude: ''
        },
        fees: '',
        faq:initialFAQs,
        time_zone: "",
        terms_and_condition: generateInitialTermsAndCondition(),
        publish_auction_results: false,
        show_bidder_location_in_bidder_history: false,
        show_bidding_history: false,
        toggle_powered_by_indy: false,
        make_your_auction_private: false,
        hide_auction_lots:false,
        passcode: "",
        font: {
            hearder_font: "",
            body_font: ""
        },
        buttons: {
            background_color: "",
            text_color: ""
        },
        header: {
            background_color: "",
            text_color: ""
        },
        content_area: {
            background_color: "",
            text_color: ""
        },
        footer: {
            background_color: "",
            text_color: ""
        },
        paddle: {
            background_color: "",
            text_color: ""
        },
        event_display: {
            enable_leaderboard: false,
            enable_carousel: false,
            background_color: "",
            background_image: "",
            left_logo_image: "",
            right_logo_image: "",
        },
    }

    useEffect(()=>{
        let originalDescriptionValue = "";
        if(state?.state){
            originalDescriptionValue = state.state.description;
        }
        const editedAuctionDataLength = Object.keys(editedAuctionData).length;
        if(editedAuctionDataLength> 0 && editedAuctionData.description &&editedAuctionData.description !== originalDescriptionValue){
            // console.log(Object.keys(editedAuctionData).length, editedAuctionData.description)
        }
    },[editedAuctionData]);

    let [auctionData, setAuctionData] = useState(initialState);
    const [saveDraftModal,setSaveDraftModal] = useState(false)
    const [errorMessages, setErrorMessages] = useState({
        logoError: '',
        logoRedirectionUrlError: '',
        auction_image_error: ''
    })
    const [newMenuLink, setNewMenuLink] = useState({
        title: '',
        link_url: '',
        dropdown: [{ title: '', link_url: ''}]
    });
    const [menuLinkError, setMenuLinkError] = useState({
        title: false,
        url: false,
    });
    const [isAddingDropdown, setIsAddingDropdown] = useState(false);
    const [menuModal, setMenuModal] = useState(false)
    const [dropdownLinkError, setDropdownLinkError] = useState([]);
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [startHour,setStartHour] = useState('')
    const [startMin,setStartMin] = useState('')
    const [endHour,setEndHour] = useState('')
    const [endMin,setEndMin] = useState('')
    const [loader, setLoader] = useState(false)
    const Navigate = useNavigate();
    const [logoLoader,setLogoLoader] = useState(false);
    const [imageLoader,setImageLoader] = useState(false);
    const [eventDisplayImageLoader, setEventDisplayImageLoader] = useState(false);
    const [eventRightLogoLoader, setEventRightLogoLoader] = useState(false);
    const [eventLeftLogoLoader, setEventLeftLogoLoader] = useState(false);
    const [oldS3Images, setOldS3Images] = useState([]);
    
    // Local image storage for preview
    const [localImages, setLocalImages] = useState({
        logo_image: null,
        auction_image: null,
        event_display_background_image: null,
        event_display_left_logo_image: null,
        event_display_right_logo_image: null
    });
    const [invalidDate, setInvalidDate]=useState(false);
    const [sameTime, setSameTime]=useState(false);
    const [startDateBeforeCurrent, setStartDateBeforeCurrent]=useState(false);
    const [text, setText]=useState("");
    const [descriptionUploading, setDescriptionUploading] = useState(false);
    const imageTrackerRef = useRef([]);
    const quillModules = useRef(getQuillModules(imageTrackerRef, setDescriptionUploading, (msg) => { setErrorMessages(prev => ({ ...prev, description_image_error: msg })); setTimeout(() => setErrorMessages(prev => ({ ...prev, description_image_error: '' })), 5000); }));
    const [mobileModal, isMobileModal] = useState(false);
    const [editMenu, setEditMenu] = useState({state: false, index: ''})

    useEffect(() => {
        if (!validTemplates.includes(template)) {
            Navigate('/page-not-found', { replace: true });
        }
    },[])

    const handleDropdownClose=()=>{
        setMenuModal(false);
        document.body.classList.remove('modal-open');
        isMobileModal(false);
        setMenuLinkError({
            title: false,
            url: false,
        });
        setNewMenuLink({
            title: '',
            link_url: '',
            dropdown: [{ title: '', link_url: ''}]
        })
        setIsAddingDropdown(false);
    }

    useOnClickOutside(outsideClickRef, () => {
        handleDropdownClose()
    });

    const handleView = async()=>{
        const response = await dataService.viewAuction(`?auction_id=${id}`)
        if(response.error===false){
            const data = response.data.data;
            setAuctionData(
                {
                    ...data,
                    template_name: localStorage.getItem('selectedTemplateId')==1?'Classic':(localStorage.getItem('selectedTemplateId')==2?'Single Lot': 'Standalone'),
                }
            )
            const startTimestamp = data.start_date;
            const endTimestamp = data.first_lot_end_date ? data.first_lot_end_date : data.end_date;
            const timezone = data.timezone;

            // Function to convert timestamp to date in a particular timezone
            const getDateInTimezone = (timestamp, timezone, locationTimeZone) => {
                let timeZone = timeZoneMap[timezone];
                if(locationTimeZone){
                    timeZone = locationTimeZone.timeZoneId;
                }else{
                    timeZone = timeZoneMap[timezone] || 'Etc/GMT';
                }
                return new Date(timestamp).toLocaleString('en-US', { timeZone:  timeZone});
            };

            // Get date, hour, and minute of start date in the specified timezone
            const startDate = startTimestamp ? new Date(getDateInTimezone(startTimestamp, data.time_zone, data.start_time_zone)) : null;
            const startHour = startDate ? String(startDate.getHours()).padStart(2, '0') : '';
            const startMin = startDate ? String(startDate.getMinutes()).padStart(2, '0') : '';

            // Get date, hour, and minute of end date in the specified timezone
            const endDate = endTimestamp ? new Date(getDateInTimezone(endTimestamp, data.time_zone, data.end_time_zone)) : null;
            const endHour = endDate ? String(endDate.getHours()).padStart(2, '0') : '';
            const endMin = endDate ? String(endDate.getMinutes()).padStart(2, '0') : '';

            // Now you can use startHour, startMin, endHour, endMin as needed
            setStartDate(data.start_date ? startDate : "");
            setStartHour(startHour);
            setStartMin(startMin);
            setEndDate(data.end_date ? endDate: "");
            setEndHour(endHour);
            setEndMin(endMin);
            setText(data?.description);
            imageTrackerRef.current.push(...getDescriptionImageUrls(data?.description));
            setLoading(false);
        }
    }

    useEffect(()=>{
        if(edit){
            setLoading(true);
            handleView();
        }
    },[])

    // Cleanup local image URLs on component unmount to prevent memory leaks
    useEffect(() => {
        return () => {
            Object.values(localImages).forEach(imageData => {
                if (imageData?.localUrl) {
                    URL.revokeObjectURL(imageData.localUrl);
                }
            });
        };
    }, []);
  
    /**
     * The function `handleLogoChange` is used to handle the change event when a logo file is selected,
     * and it updates the state with the selected logo image and displays an error message if the file
     * size exceeds 5MB.
     */
    const handleLogoChange = async(event, image_type) => {
        if(image_type === 'logo'){
            setLogoLoader(true);
        } else if (image_type === 'event_display_image') {
            setEventDisplayImageLoader(true);
        } else if (image_type === 'event_right_logo') {
            setEventRightLogoLoader(true);
        } else if (image_type === 'event_left_logo') {
            setEventLeftLogoLoader(true);
        } else {
            setImageLoader(true);
        }
        const selectedLogo = event.target.files[0];
        const validLogoTypes = ['image/jpeg', 'image/png', "image/jpg"];
        const validImageTypes = ['image/jpeg', 'image/png', "image/jpg", 'image/gif'];
        if(image_type === 'logo'){
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                logoError: ""
            }));
        } else if (image_type === 'event_display_image') {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                event_display_image_error: ""
            }));
        } else if (image_type === 'event_right_logo') {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                event_right_logo_error: ""
            }));
        } else if (image_type === 'event_left_logo') {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                event_left_logo_error: ""
            }));
        } else {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                auction_image_error: ""
            }));
        }
        if (image_type === 'logo') {
            if (!validLogoTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    logoError: "Please select a logo file in JPG or PNG format."
                }));
                setLogoLoader(false);
                return;
            }
        } else if (image_type === 'event_display_image') {
            if (!validImageTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    event_display_image_error: "Please select an event display image in JPG, PNG or GIF format."
                }));
                setEventDisplayImageLoader(false);
                return;
            }
        } else if (image_type === 'event_right_logo') {
            if (!validImageTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    event_right_logo_error: "Please select a right logo image in JPG, PNG or GIF format."
                }));
                setEventRightLogoLoader(false);
                return;
            }
        } else if (image_type === 'event_left_logo') {
            if (!validImageTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    event_left_logo_error: "Please select a left logo image in JPG, PNG or GIF format."
                }));
                setEventLeftLogoLoader(false);
                return;
            }
        } else {
            if (!validImageTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    auction_image_error: "Please select a lead image in JPG, PNG or GIF format."
                }));
                setImageLoader(false);
                return;
            }
        }

        if (selectedLogo && selectedLogo.size <= 5 * 1024 * 1024) {
            // Track old S3 image for deletion if replacing an existing image
            if(image_type==='logo'){
                if (auctionData.logo_image && !auctionData.logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.logo_image]);
                }
            } else if (image_type === 'event_display_image') {
                if (auctionData.event_display?.background_image && !auctionData.event_display.background_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.event_display.background_image]);
                }
            } else if (image_type === 'event_right_logo') {
                if (auctionData.event_display?.right_logo_image && !auctionData.event_display.right_logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.event_display.right_logo_image]);
                }
            } else if (image_type === 'event_left_logo') {
                if (auctionData.event_display?.left_logo_image && !auctionData.event_display.left_logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.event_display.left_logo_image]);
                }
            } else {
                if (auctionData.auction_image && !auctionData.auction_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.auction_image]);
                }
            }

            // Create local URL for preview
            const localImageUrl = URL.createObjectURL(selectedLogo);
            
            // Store the file and local URL for later S3 upload
            const imageData = {
                file: selectedLogo,
                localUrl: localImageUrl,
                name: selectedLogo.name,
                type: selectedLogo.type
            };

            if(image_type==='logo'){
                setLocalImages(prev => ({
                    ...prev,
                    logo_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    logo_image: localImageUrl // Use local URL for preview
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    logo_image: localImageUrl
                }));
                setTimeout(() => {
                    setLogoLoader(false)
                    setImageLoader(false);
                }, 500);
            } else if (image_type === 'event_display_image') {
                setLocalImages(prev => ({
                    ...prev,
                    event_display_background_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    event_display: {
                        ...prevData.event_display,
                        background_image: localImageUrl
                    }
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    event_display: {
                        ...prevData.event_display,
                        background_image: localImageUrl
                    }
                }));
                setTimeout(() => {
                    setEventDisplayImageLoader(false);
                }, 500);
            } else if (image_type === 'event_left_logo') {
                setLocalImages(prev => ({
                    ...prev,
                    event_display_left_logo_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    event_display: {
                        ...prevData.event_display,
                        left_logo_image: localImageUrl
                    }
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    event_display: {
                        ...prevData.event_display,
                        left_logo_image: localImageUrl
                    }
                }));
                setTimeout(() => {
                    setEventLeftLogoLoader(false);
                }, 500);
            } else if (image_type === 'event_right_logo') {
                setLocalImages(prev => ({
                    ...prev,
                    event_display_right_logo_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    event_display: {
                        ...prevData.event_display,
                        right_logo_image: localImageUrl
                    }
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    event_display: {
                        ...prevData.event_display,
                        right_logo_image: localImageUrl
                    }
                }));
                setTimeout(() => {
                    setEventRightLogoLoader(false);
                }, 500);
            } else {
                setLocalImages(prev => ({
                    ...prev,
                    auction_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    auction_image: localImageUrl
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    auction_image: localImageUrl
                }));
                setTimeout(() => {
                    setLogoLoader(false)
                    setImageLoader(false);
                }, 500);
            }
        } else {
            if(image_type === 'logo'){
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    logoError: "Please select a logo file smaller than 5MB."
                }));
                setLogoLoader(false);
            } else if (image_type === 'event_display_image') {
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    event_display_image_error: "Please select a lead image smaller than 5MB."
                }));
                setEventDisplayImageLoader(false);
            } else if (image_type === 'event_left_logo') {
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    event_left_logo_error: "Please select a left logo image smaller than 5MB."
                }));
                setEventLeftLogoLoader(false);
            } else if (image_type === 'event_right_logo') {
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    event_right_logo_error: "Please select a right logo image smaller than 5MB."
                }));
                setEventRightLogoLoader(false);
            } else {
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    auction_image_error: "Please select a lead image smaller than 5MB."
                }));
                setImageLoader(false);
            }
        }
    };
    /**
     * The function `handleLogoDelete` is used to delete local images and clear the preview.
     * S3 deletion is removed for security - images will only be uploaded when auction is saved.
     */
    const handleLogoDelete = (image_type) => {
        try {
            let updateAuction = {};
            let updateEdited = {};
            let errorKey = "";
            let stopLoader = () => {};
            let localImageKey = "";

            // Track old S3 image for deletion
            if (image_type === "logo") {
                if (auctionData.logo_image && !auctionData.logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.logo_image]);
                }
                localImageKey = "logo_image";
                updateAuction = { logo_image: "", logo_redirection_url: "" };
                updateEdited = { logo_image: "", logo_redirection_url: "" };
                errorKey = "logoError";
                stopLoader = () => setLogoLoader(false);
            } else if (image_type === "event_display_image") {
                if (auctionData.event_display?.background_image && !auctionData.event_display.background_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.event_display.background_image]);
                }
                localImageKey = "event_display_background_image";
                updateAuction = { event_display: { ...auctionData.event_display, background_image: "" } };
                updateEdited = { event_display: { ...editedAuctionData.event_display, background_image: "" } };
                errorKey = "event_display_image_error";
                stopLoader = () => setEventDisplayImageLoader(false);
            } else if (image_type === "event_right_logo") {
                if (auctionData.event_display?.right_logo_image && !auctionData.event_display.right_logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.event_display.right_logo_image]);
                }
                localImageKey = "event_display_right_logo_image";
                updateAuction = { event_display: { ...auctionData.event_display, right_logo_image: "" } };
                updateEdited = { event_display: { ...editedAuctionData.event_display, right_logo_image: "" } };
                errorKey = "event_right_logo_error";
                stopLoader = () => setEventRightLogoLoader(false);
            } else if (image_type === "event_left_logo") {
                if (auctionData.event_display?.left_logo_image && !auctionData.event_display.left_logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.event_display.left_logo_image]);
                }
                localImageKey = "event_display_left_logo_image";
                updateAuction = { event_display: { ...auctionData.event_display, left_logo_image: "" } };
                updateEdited = { event_display: { ...editedAuctionData.event_display, left_logo_image: "" } };
                errorKey = "event_left_logo_error";
                stopLoader = () => setEventLeftLogoLoader(false);
            } else {
                if (auctionData.auction_image && !auctionData.auction_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.auction_image]);
                }
                localImageKey = "auction_image";
                updateAuction = { auction_image: "" };
                updateEdited = { auction_image: "" };
                errorKey = "auction_image_error";
                stopLoader = () => setImageLoader(false);
            }

            // Clean up local image URL to prevent memory leaks
            if (localImages[localImageKey]?.localUrl) {
                URL.revokeObjectURL(localImages[localImageKey].localUrl);
            }

            // Clear local image data
            setLocalImages(prev => ({
                ...prev,
                [localImageKey]: null
            }));

            setAuctionData((prev) => ({ ...prev, ...updateAuction }));
            setEditedAuctionData((prev) => ({ ...prev, ...updateEdited }));
            setErrorMessages((prev) => ({ ...prev, [errorKey]: "" }));
            stopLoader();
        } catch (error) {
            console.error(`Error deleting ${image_type}:`, error);
        }
    };

    /**
     * The function `handleLogoRedirectionChange` validates a URL entered by the user and updates the
     * state accordingly.
     */
    const handleLogoRedirectionChange = (event) => {
        event.preventDefault();
        const newRedirectionUrl = event.target.value;
        const regex= '^(https?://|www\.)[a-zA-Z0-9@:%._\\+-~#?&//=]{2,256}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)'
        const urlPattern = new RegExp(regex);
        if (urlPattern.test(newRedirectionUrl) || newRedirectionUrl==='') {
            setAuctionData(prevData => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
            setEditedAuctionData((prevData) => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                logoRedirectionUrlError: ""
            }));
        } else {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                logoRedirectionUrlError: "Enter a valid URL"
            }));
            setAuctionData(prevData => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
            setEditedAuctionData((prevData) => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
        }
    };
    /**
     * The function `addMenuLink` adds a new menu link to the `auctionData` state if the number of menu
     * links is less than 7.
     */


    const addMenuLink = () => {
        if(editMenu.state){
            setAuctionData((prevState) => ({
                ...prevState,
                menu_links: prevState.menu_links.map((link, index) =>
                    index === editMenu.index ? { ...link, ...newMenuLink } : link
                ),
            }));
        }else{
            setAuctionData((prevState) => ({
                ...prevState,
                menu_links: [...prevState.menu_links, newMenuLink],
            }));
        }
        setNewMenuLink({
            title: '',
            link_url: '',
            dropdown: [{
                title: '',
                link_url: '',
            }],
        });
        setIsAddingDropdown(false)
        setMenuModal(false)
        document.body.classList.remove('modal-open')
    };
    /**
     * The deleteMenuLink function is used to remove a menu link from the auction data by filtering out
     * the link at the specified index.
     */
    const deleteMenuLink = (index) => {
        setAuctionData((prevState) => ({
            ...prevState,
            menu_links: prevState.menu_links.filter((_, i) => i !== index),
        }));
    };
    /**
     * The function `addDropdownLink` adds a new dropdown link to the `newMenuLink` state if the number
     * of existing dropdown links is less than 5.
     */
    const addDropdownLink = () => {
        if (newMenuLink.dropdown.length < 5) {
            setNewMenuLink((prevState) => ({
                ...prevState,
                dropdown: [
                    ...prevState.dropdown,
                    {
                        title: '',
                        link_url: '',
                    },
                ],
            }));
        }
    };
    
    /**
     * Helper function to upload local images to S3
     */
    const uploadImagesToS3 = async (imageData) => {
        if (!imageData?.file) return null;
        
        try {
            const webpImage = await convertToWebP(imageData.file);
            const upload = await Storage.put(`DomainName/Auctions/images/${uuid()}/${webpImage.name.replaceAll(' ','')}`, webpImage, {
                contentType: webpImage.type,
            });
            return upload.key;
        } catch (error) {
            console.error('Error uploading image to S3:', error);
            return null;
        }
    };

    const deleteOldS3Images = async () => {
        try {
            if (!oldS3Images || oldS3Images.length === 0) return;
    
            const deletePromises = oldS3Images.map((imageKey) => {
                const body = { key: imageKey };
                return dataService.deleteImageFromS3(body);
            });
    
            await Promise.all(deletePromises);
    
        } catch (error) {
            console.error("Error deleting old S3 images:", error);
        }
    };


    /**
     * The function `handleCreateAuction` is an asynchronous function that handles the creation of an
     * auction by uploading images to S3 first, then making an API call to create the auction.
     */
    const handleCreateAuction = async(e)=>{
        e.preventDefault();
        setLoader(true)
        let data;

        try {
            // Upload all local images to S3 first
            const uploadPromises = [];
            const imageKeys = {};

            // Upload logo image
            if (localImages.logo_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.logo_image).then(key => {
                        if (key) imageKeys.logo_image = key;
                    })
                );
            }

            // Upload auction image
            if (localImages.auction_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.auction_image).then(key => {
                        if (key) imageKeys.auction_image = key;
                    })
                );
            }

            // Upload event display images
            if (localImages.event_display_background_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.event_display_background_image).then(key => {
                        if (key) imageKeys.event_display_background_image = key;
                    })
                );
            }

            if (localImages.event_display_left_logo_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.event_display_left_logo_image).then(key => {
                        if (key) imageKeys.event_display_left_logo_image = key;
                    })
                );
            }

            if (localImages.event_display_right_logo_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.event_display_right_logo_image).then(key => {
                        if (key) imageKeys.event_display_right_logo_image = key;
                    })
                );
            }

            // Wait for all uploads to complete
            await Promise.all(uploadPromises);

            // Delete old S3 images after successful upload
            await deleteOldS3Images();

            // Delete orphaned description images from S3
            const orphanedKeys = getOrphanedDescriptionImageKeys(imageTrackerRef.current, auctionData.description);
            if (orphanedKeys.length > 0) {
                await Promise.all(orphanedKeys.map(key => dataService.deleteImageFromS3({ key })));
            }
            imageTrackerRef.current.length = 0;

            // Prepare auction data with S3 keys
            let finalAuctionData = { ...auctionData };
            
            // Replace local URLs with S3 keys
            if (imageKeys.logo_image) {
                finalAuctionData.logo_image = imageKeys.logo_image;
            }
            if (imageKeys.auction_image) {
                finalAuctionData.auction_image = imageKeys.auction_image;
            }
            if (imageKeys.event_display_background_image) {
                finalAuctionData.event_display = {
                    ...finalAuctionData.event_display,
                    background_image: imageKeys.event_display_background_image
                };
            }
            if (imageKeys.event_display_left_logo_image) {
                finalAuctionData.event_display = {
                    ...finalAuctionData.event_display,
                    left_logo_image: imageKeys.event_display_left_logo_image
                };
            }
            if (imageKeys.event_display_right_logo_image) {
                finalAuctionData.event_display = {
                    ...finalAuctionData.event_display,
                    right_logo_image: imageKeys.event_display_right_logo_image
                };
            }

            if (auctionData?.buyer_fee_details) {
                finalAuctionData.buyer_fee_details = auctionData.buyer_fee_details;
            }

            if(!edit){
                if(finalAuctionData.extension_time==""){
                    finalAuctionData={...finalAuctionData, extension_time: 2}
                }
                data = await dataService.CreateAuction(finalAuctionData);
                if(data.error==false){
                    setAuctionData(initialState)
                    setSaveDraftModal(false)
                    setLoader(false)
                    if(data!==undefined && data.data.auctions_id!==undefined){
                        Navigate(`/auctions/${data.data._id}/${data.data.auctions_id}/overview`, 
                            {state: {message: 'Your auction has been created and saved as a draft'}})
                    }
                }else{
                    setSaveDraftModal(false)
                    setLoader(false)
                }
            }
            else{
                // Add any new image keys to edited data
                const updatedData = { ...editedAuctionData };
                Object.keys(imageKeys).forEach(key => {
                    if (imageKeys[key]) {
                        if (key.includes('event_display_')) {
                            // Handle event display images
                            const eventKey = key.replace('event_display_', '');
                            if (!updatedData.event_display) {
                                updatedData.event_display = {};
                            }
                            updatedData.event_display[eventKey] = imageKeys[key];
                        } else {
                            updatedData[key] = imageKeys[key];
                        }
                    }
                });
                
                // Always include menu_links, faq and event_display as they are managed separately
                updatedData.menu_links = auctionData.menu_links;
                updatedData.faq = auctionData.faq;
                updatedData.event_display = {...auctionData.event_display, ...updatedData.event_display};
                if (auctionData?.buyer_fee_details) {
                    updatedData.buyer_fee_details = auctionData.buyer_fee_details;
                }
                if (editedAuctionData?.event_display?.background_image) {
                    delete updatedData.event_display.background_color;
                }
                if (editedAuctionData?.event_display?.background_color) {
                    delete updatedData.event_display.background_image;
                }
                setTimeout(async() => {
                    data = await dataService.editAuction(auctionData.auction_id, updatedData)
                    if(data.error==false){
                        setAuctionData(initialState)
                        setSaveDraftModal(false)
                        setLoader(false)
                        if(auctionData.status=="Draft"){
                            Navigate(`/auctions/${id}/${auctionData.auction_id}/overview`, 
                                {state: {message: 'Your auction has been updated and saved as a draft' }})
                        }else{
                            Navigate(`/auctions/${id}/${auctionData.auction_id}/overview`, 
                                {state: {message: 'Your auction has been updated'}})
                        }
                    }else{
                        if(data?.message?.status==400){
                            Navigate(`/auctions/${auctionData._id}/${auctionData.auction_id}/overview`, 
                                {state: {error: data.message.data.message }})
                        }else{
                            Navigate(`/auctions/${auctionData._id}/${auctionData.auction_id}/overview`, 
                                {state: {error: 'Something went wrong, please try again'}})
                        }
                    }
                }, 500);
            }
        } catch (error) {
            console.error('Error in handleCreateAuction:', error);
            setLoader(false);
            setSaveDraftModal(false);
        }
    }
    /**
     * The function `deleteDropdownLink` is used to remove a dropdown link from a menu and update the
     * state accordingly.
     */
    const deleteDropdownLink = (dropdownIndex) => {
        setNewMenuLink((prevState) => {
            const updatedLinks = prevState.dropdown.slice();
            if (Array.isArray(updatedLinks)) {
                if (dropdownIndex >= 0 && dropdownIndex < updatedLinks.length) {
                    updatedLinks.splice(dropdownIndex, 1);
                }
            }
            if(updatedLinks.length===0){
                setIsAddingDropdown(false)
                return {
                    ...prevState,
                    dropdown: [{ title: '', link_url: ''}]
                };
            }
            // setDropdownLinkError([])
            return {
                ...prevState,
                dropdown: updatedLinks, 
            };
        });
    };

    return (
        <div className="bg-[#F4F4F5] " >
            <AuctionHeader auctionData={auctionData} setAuctionData={setAuctionData}
                setEditedAuctionData={setEditedAuctionData}
                handleLogoChange={handleLogoChange}
                handleLogoRedirectionChange={handleLogoRedirectionChange} handleLogoDelete={handleLogoDelete}
                errorMessages={errorMessages}
                invalidDate={invalidDate}
                sameTime={sameTime}
                startDateBeforeCurrent={startDateBeforeCurrent}
                deleteMenuLink={deleteMenuLink}
                addDropdownLink={addDropdownLink}
                deleteDropdownLink={deleteDropdownLink}
                setNewMenuLink={setNewMenuLink}
                isAddingDropdown={isAddingDropdown} 
                setIsAddingDropdown={setIsAddingDropdown}
                setMenuModal={setMenuModal}
                startDate={startDate} 
                setStartDate={setStartDate}
                endDate={endDate} 
                setEndDate={setEndDate}
                startHour={startHour}
                setStartHour={setStartHour}
                startMin={startMin}
                setStartMin={setStartMin}
                endHour={endHour}
                setEndHour={setEndHour}
                endMin={endMin}
                setEndMin={setEndMin}
                handleCreateAuction={handleCreateAuction}
                saveDraftModal={saveDraftModal}
                setSaveDraftModal={setSaveDraftModal}
                loader={loader || descriptionUploading}
                menuLinkError={menuLinkError} 
                logoLoader={logoLoader}
                setLogoLoader={setLogoLoader}
                imageLoader={imageLoader}
                setImageLoader={setImageLoader}
                setSameTime={setSameTime}
                setInvalidDate={setInvalidDate}
                setStartDateBeforeCurrent={setStartDateBeforeCurrent}
                mobileModal={mobileModal}
                isMobileModal={isMobileModal}
                setEditMenu={setEditMenu} edit={edit}
                isBanner={isBanner} setIsBanner={setIsBanner}
                onSetupSectionChange={setShowEventDisplayPreview}
            />
            <div className={`w-full flex ${isBanner ? 'h-[calc(100vh-68px)]' : 'mt-[45px] max-h-[calc(100vh-113px)]' } `}>
                {!showEventDisplayPreview ? (
                    (template=='classic' ?
                        <ClassicPreview auctionData={auctionData}
                            startDate={startDate} 
                            setStartDate={setStartDate}
                            endDate={endDate} 
                            setEndDate={setEndDate}
                            startHour={startHour}
                            setStartHour={setStartHour}
                            startMin={startMin}
                            setStartMin={setStartMin}
                            endHour={endHour}
                            setEndHour={setEndHour}
                            endMin={endMin}
                            setEndMin={setEndMin}
                        />
                        : (template=='single-lot'?
                            <SingleLotPreview auctionData={auctionData}
                                startDate={startDate} 
                                setStartDate={setStartDate}
                                endDate={endDate} 
                                setEndDate={setEndDate}
                                startHour={startHour}
                                setStartHour={setStartHour}
                                startMin={startMin}
                                setStartMin={setStartMin}
                                endHour={endHour}
                                setEndHour={setEndHour}
                                endMin={endMin}
                                setEndMin={setEndMin}
                            />
                            :
                            <StandALonePreview auctionData={auctionData}
                                startDate={startDate} 
                                setStartDate={setStartDate}
                                endDate={endDate} 
                                setEndDate={setEndDate}
                                startHour={startHour}
                                setStartHour={setStartHour}
                                startMin={startMin}
                                setStartMin={setStartMin}
                                endHour={endHour}
                                setEndHour={setEndHour}
                                endMin={endMin}
                                setEndMin={setEndMin}
                            />
                        )
                        
                    )
                )
                    : <EventDisplayPreview auctionData={auctionData} height={isBanner ? 'h-[calc(100vh-68px)]' : 'min-h-[calc(100vh-113px)]' } />
                }
                <div id='web-panel-configuration' 
                    className={`xl:w-[26%] lg:w-[30%] md:w-[40%] md:block hidden border-l 
                        border-[#D4D4D8] bg-[#fff] 
                        ${isBanner ? 'h-[calc(100vh-68px)]' : 'max-h-[calc(100vh-113px)]' }
                        overflow-y-scroll customScrollbar`}>
                    <SetupSection
                        quillModules={quillModules.current}
                        auctionData={auctionData}
                        setAuctionData={setAuctionData}
                        customId='auction_title'
                        customId1='auction_description'
                        date='auction_start_date'
                        setEditedAuctionData={setEditedAuctionData}
                        setText={setText}
                        text={text}
                        handleLogoChange={handleLogoChange}
                        invalidDate={invalidDate}
                        setInvalidDate={setInvalidDate}
                        sameTime={sameTime}
                        setSameTime={setSameTime}
                        startDateBeforeCurrent={startDateBeforeCurrent}
                        setStartDateBeforeCurrent={setStartDateBeforeCurrent}
                        handleLogoRedirectionChange={handleLogoRedirectionChange}
                        handleLogoDelete={handleLogoDelete}
                        errorMessages={errorMessages}
                        deleteMenuLink={deleteMenuLink}
                        setNewMenuLink={setNewMenuLink}
                        setMenuModal={setMenuModal}
                        startDate={startDate} 
                        setStartDate={setStartDate}
                        endDate={endDate} 
                        setEndDate={setEndDate}
                        startHour={startHour}
                        setStartHour={setStartHour}
                        startMin={startMin}
                        setStartMin={setStartMin}
                        endHour={endHour}
                        setEndHour={setEndHour}
                        endMin={endMin}
                        setEndMin={setEndMin}
                        logoLoader={logoLoader}
                        setLogoLoader={setLogoLoader}
                        imageLoader={imageLoader}
                        setImageLoader={setImageLoader}
                        eventDisplayImageLoader={eventDisplayImageLoader}
                        eventRightLogoLoader={eventRightLogoLoader}
                        eventLeftLogoLoader={eventLeftLogoLoader}
                        isMobileModal ={isMobileModal}
                        setEditMenu={setEditMenu}
                        edit={edit}
                        onSetupSectionChange={setShowEventDisplayPreview}
                    />
                </div>
            </div>
            <MenuLinkModal 
                setMenuModal={setMenuModal} 
                menuModal={menuModal} 
                outsideClickRef={outsideClickRef}
                newMenuLink={newMenuLink} 
                setNewMenuLink={setNewMenuLink} 
                addMenuLink={addMenuLink} 
                isAddingDropdown={isAddingDropdown} 
                setIsAddingDropdown={setIsAddingDropdown} 
                addDropdownLink={addDropdownLink}
                deleteDropdownLink={deleteDropdownLink}
                dropdownLinkError={dropdownLinkError} 
                setDropdownLinkError={setDropdownLinkError}
                menuLinkError={menuLinkError} 
                setMenuLinkError={setMenuLinkError}
                auctionData={auctionData}
                mobileModal = {mobileModal}
                isMobileModal={isMobileModal}
                editMenu={editMenu}
                handleDropdownClose={handleDropdownClose}
            />
            {loading && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
                    <Triangle
                        height="80"
                        width="80"
                        color="#ffff"
                        ariaLabel="triangle-loading"
                        visible={true}
                    />
                </div>
            )}
        </div>
    )
}